import { routes } from '../../../constants/routes'

export type RootSubPage = {
  name: string
  path: string | string[]
}

export type RootPage = {
  name: string
  path: string
  isWindowOpen?: boolean
}

export const navigationTabListHeader: RootPage[] = [
  {
    name: 'Terms and Conditions',
    path: routes.FILES_MTA,
    isWindowOpen: true,
  },
  {
    name: 'Privacy Policy',
    path: routes.FILES_PRIVACY_POLICY,
    isWindowOpen: true,
  },
  {
    name: 'About Us',
    path: '#',
  },
  {
    name: 'FAQ',
    path: '#',
  },
]

export const navigationTabListFooter: RootPage[] = [
  {
    name: 'Privacy Policy',
    path: routes.FILES_PRIVACY_POLICY,
    isWindowOpen: true,
  },
  {
    name: 'Terms & Conditions',
    path: routes.FILES_MTA,
    isWindowOpen: true,
  },
]
